import { styled } from "@mui/material/styles";

// Components
import { FormControl, Grid } from "@mui/material";

const styledName = "RegistrationForm";

export const StyledPassWordForm = styled(Grid, { name: styledName })({
  "&": {
    display: "flex",
    flexWrap: "nowrap",
    gap: "10px",
    height: "fit-content",
  },
});

export const StyledFormLink = styled(Grid, { name: styledName })({
  "&": {
    display: "flex",
    width: "100%",
    height: "fit-content",
  },
});

export const StyledSignUpButton = styled(FormControl, { name: styledName })({
  "&": {
    marginBottom: "22px",
  },
});

export const StyledButton = styled(FormControl, { name: styledName })({
  "&": {
    marginBottom: "8px",
  },
});

export const StyledLoginLink = styled(Grid, { name: styledName })({
  "&": {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
});
